import React from 'react';
import SectionTitle from '../../components/SectionTitle';
import SingleEvent from '../../components/Event';
import { useCollections } from '../../lib/api/collections';

import shapeImg1 from '../../assets/img/event/ed-shape-3-1.png';
import shapeImg2 from '../../assets/img/event/ed-shape-3-2.png';
import titleImg from '../../assets/img/category/title.svg';
import { eventImages } from '../../data/images';

const Event = () => {
  const { events } = useCollections('events');
  if (!events) return null;
  // Featured events first (newest first); if fewer than three are featured, the newest events fill the gaps.
  const shown = [...events.filter((e) => e.featured), ...events.filter((e) => !e.featured)]
    .slice(0, 3)
    .map((e, i) => ({ ...e, image: eventImages(e).card, delay: ['.3s', '.5s', '.7s'][i] }));

  return (
    <div
      id="it-event"
      className="it-event-2-area it-event-style-4 p-relative z-index pt-115 fix pb-70 grey-bg"
    >
      <div className="ed-event-shape-1">
        <img src={shapeImg1} alt="" />
      </div>
      <div className="ed-event-shape-2">
        <img src={shapeImg2} alt="" />
      </div>
      <div className="container">
        <div className="it-event-2-title-wrap mb-60">
          <div className="row align-items-end">
            <div className="col-12">
              <SectionTitle
                itemClass="it-event-2-title-box text-center"
                subTitleClass="it-section-subtitle-5 purple-2"
                subTitle="Campus Life"
                titleClass="it-section-title-3"
                title="Events And Celebrations"
                titleImage={titleImg}
              />
            </div>
          </div>
        </div>
        <div className="row">
          {shown.map((e) => (
            <div
              key={e.id}
              className="col-xl-4 col-lg-4 col-md-6 mb-30 wow animate__fadeInUp"
              data-wow-duration=".9s"
              data-wow-delay={e.delay}
            >
              <SingleEvent
                to={`/events/${e.id}`}
                eventImage={e.image}
                eventDate={String(e.day).padStart(2, '0')}
                eventMonth={e.month}
                title={e.title}
                description={e.summary}
                eventType={e.type}
                eventLocation={e.location}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
export default Event;
